import React from 'react';
import styles from './styles.module.scss'

const LojaWrapper = ({ children }) => {
    return (
        <div className={styles.lojaWrapper}>
            { children }
        </div>
    )
}

export default LojaWrapper;